export enum ComplianceMonitorCorporationInfoOnboardingVersionV1Step {
  REVIEW_ENTITY_DETAILS = 'REVIEW_ENTITY_DETAILS',
  VIEW_COMPLIANCE_CALENDAR = 'VIEW_COMPLIANCE_CALENDAR',
  SELECT_COMPLIANCE_METHOD = 'SELECT_COMPLIANCE_METHOD',
  SELECT_DEFAULT_ASSIGNEE = 'SELECT_DEFAULT_ASSIGNEE',
}

export enum ComplianceMonitorCorporationAdditionalOnboardingStep {
  GENERAL_BUSINESS_INFORMATION = 'GENERAL_BUSINESS_INFORMATION',
  LOCATIONS = 'LOCATIONS',
  TAX_AND_REGISTRATIONS = 'TAX_AND_REGISTRATIONS',
  KEY_PERSONS = 'KEY_PERSONS',
  OWNERSHIP = 'OWNERSHIP',
  CREDENTIALS = 'CREDENTIALS',
  REVIEW_AND_CONFIRMATION = 'REVIEW_AND_CONFIRMATION',
}

export enum ComplianceMonitorCorporationInfoMethod {
  DO_IT_YOURSELF = 'DO_IT_YOURSELF',
  FILE_WITH_COMMENDA = 'FILE_WITH_COMMENDA',
  USE_A_PURCHASED_PLAN = 'USE_A_PURCHASED_PLAN',
}

export enum ComplianceMonitorCorporationInfoOnboardingStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export type TComplianceMonitors = {
  complianceMonitors: TComplianceMonitorCorporationInfo[];
  totalComplianceMonitors: number;
};

export type TComplianceMonitorCorporationInfoOnboardingV1 = {
  complianceMethod: ComplianceMonitorCorporationInfoMethod;
  steps: {
    order: number;
    finishedAt: Date;
    type: ComplianceMonitorCorporationInfoOnboardingVersionV1Step;
    isCompleted: boolean;
  }[];
  status: ComplianceMonitorCorporationInfoOnboardingStatus;
};
export type TComplianceSpecificOnboardingV1 = {
  steps: {
    order: number;
    finishedAt: Date;
    type: ComplianceMonitorCorporationAdditionalOnboardingStep;
    isCompleted: boolean;
  }[];
};

export type TComplianceMonitorCorporationInfo = {
  corporation: {
    id: number;
  };
  onboardingInformation: TComplianceMonitorCorporationInfoOnboardingV1;
  complianceSpecificOnboardingInformation: TComplianceSpecificOnboardingV1;
};
